var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-main',[_c('Header'),_c('LoadingSpinner',{attrs:{"isLoading":_vm.$store.getters.isLoading}}),_c('router-view'),_c('Footer')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }